var React = require('react');

function Times (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.70508 3.34106L2.91387 9.13227","stroke":"white","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M8.70502 9.13203L2.91382 3.34082","stroke":"white","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","key":1})]);
}

Times.defaultProps = {"width":"12","height":"13","viewBox":"0 0 12 13","fill":"none"};

module.exports = Times;

Times.default = Times;
